import "./secondaryButton.scss";

export function SecondaryButton(props: {text: string | undefined, function: Function, negative:boolean }) {
  let negative = props.negative
  return (
    <button className={negative?("negative"):("gno-secondary-button")} onClick={() => props.function()}>{props.text}</button>
  );
}